"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** scroll to the top and left of specified element */
exports.scrollToItemStart = function (scrollEl, itemEl) {
    if (scrollEl && itemEl) {
        scrollEl.scrollTop = itemEl.offsetTop - 10;
        scrollEl.scrollLeft = itemEl.offsetLeft;
    }
};
/** scroll to the bottom and right of specified element */
exports.scrollToItemEnd = function (scrollEl, itemEl) {
    if (scrollEl && itemEl) {
        scrollEl.scrollTop =
            itemEl.offsetTop - (scrollEl.clientHeight - itemEl.clientHeight - 10);
        scrollEl.scrollLeft =
            itemEl.offsetLeft - (scrollEl.clientWidth - itemEl.clientWidth);
    }
};
/** scroll to keep specified element inside visible scroll area when part of element is out of view */
exports.scrollToItemWhenOutsideVisibleScroll = function (scrollEl, itemEl) {
    if (scrollEl && itemEl) {
        var scrollViewTop = scrollEl.scrollTop;
        var scrollViewBottom = scrollViewTop + scrollEl.offsetHeight;
        var itemTop = itemEl.offsetTop;
        var itemBottom = itemTop + itemEl.offsetHeight;
        var scrollViewLeft = scrollEl.scrollLeft;
        var scrollViewRight = scrollViewLeft + scrollEl.offsetWidth;
        var itemLeft = itemEl.offsetLeft;
        var itemRight = itemLeft + itemEl.offsetWidth;
        if (itemBottom > scrollViewBottom || itemRight > scrollViewRight) {
            exports.scrollToItemEnd(scrollEl, itemEl);
        }
        else if (itemTop < scrollViewTop || itemLeft < scrollViewLeft) {
            exports.scrollToItemStart(scrollEl, itemEl);
        }
    }
};
